import {h, Component} from 'preact';
import OptionGroupList from './OptionGroupList';
import SizedImage from '../../common/SizedImage';
import cx from 'classnames';

var card = {
    rule: 'md:border-b border-grey-lighter border-solid',
    root: 'category-card flex flex-grow hover:z-10 relative border-b border-r border-grey-lighter border-solid md:border-0',
    inner: 'category-card-inner link4 block md:absolute w-full p-4 bg-white border border-solid',
    thumbnail: 'card-media img-ratio-4x3',
    info: 'category-card-info mt-4',
    title: 'card-title text-base pt-1 mb-1 leading-tight',
    subtitle: 'card-subtitle leading-tight'
};

class CategoryTile extends Component {
    state = {
        isActive: true,
        selectedOption: null
    };

    onOptionSelect = selectedOption => {
        this.setState( {selectedOption} );
    };

    handleHoverState = e => {
        this.setState( {isActive: e.type === 'mouseenter'} );
    };

    getDetails ( props ) {
        const {url, images, groupId, ...sendProps} = {...props, ...this.state.selectedOption};

        return {
            ...sendProps,
            previewSrc: images.length && images[0].src,
            url: groupId ? `${url}?group=${groupId}` : url
        };
    }

    render () {
        const activeState = this.state.isActive ? 'border-grey' : 'border-white';

        const {id, name, description, optionGroups, url, previewSrc} = this.getDetails( this.props );

        return (
            <article productId={id} className={card.root} onMouseLeave={this.handleHoverState}>
                <a className={cx( card.inner, activeState )} href={url}>
                    <div className={card.thumbnail} onMouseEnter={this.handleHoverState}>
                        <SizedImage src={previewSrc} alt={name} width={512}/>
                    </div>
                    <div className={card.info}>
                        <OptionGroupList isActive={this.state.isActive}
                                         list={optionGroups}
                                         onSelect={this.onOptionSelect}/>
                        <h3 className={card.title}>{this.props.name}</h3>
                        <p className={card.subtitle}>{description}</p>
                    </div>
                </a>
            </article>
        );
    }
}

export default CategoryTile;
